import { configure, defineRule } from 'vee-validate'
import {
    alpha_num,
    digits,
    email,
    max,
    min,
    one_of,
    required
} from '@vee-validate/rules'
import { isValidCrefoPassword } from '@dm/is-valid-crefo-password'
import { localize, setLocale } from '@vee-validate/i18n'
import de from '@/helper/vee-validate-standard-messages-de.json'
import en from '@/helper/vee-validate-standard-messages-en.json'
import fr from '@/helper/vee-validate-standard-messages-fr.json'

export default (defaultLocale = 'de') => {
    function isEmpty(value) {
        if (value === null || value === undefined || value === '') {
            return true
        }
        return Array.isArray(value) && value.length === 0
    }

    defineRule('required', required)
    defineRule('email', email)
    defineRule('min', min)
    defineRule('min', min)
    defineRule('max', max)
    defineRule('digits', digits)
    defineRule('included', one_of)
    defineRule('alpha_num', alpha_num)
    defineRule('confirmed', (value, [target], ctx) => {
        return value === ctx.form[target]
    })
    defineRule('required_if', (value, [target], ctx) => {
        // Check if the target field exists and has truthy value
        if (ctx.form && ctx.form[target] && ctx.form[target] !== '0') {
            // If the target field exists and is not null, then apply 'required' rule
            return required(value)
        }
        // If the target field doesn't exist or is null, return true indicating no validation error
        return true
    })
    defineRule('verify_mc_password', value => {
        // Field is empty, should pass
        return isValidCrefoPassword(value).valid
    })
    defineRule('verify_mc_password_length', value => {
        return isValidCrefoPassword(value).checks.length
    })
    defineRule(
        'verify_mc_password_upper',
        value => isValidCrefoPassword(value).checks.upper
    )
    defineRule(
        'verify_mc_password_lower',
        value => isValidCrefoPassword(value).checks.lower
    )
    defineRule(
        'verify_mc_password_digit',
        value => isValidCrefoPassword(value).checks.digit
    )
    defineRule(
        'verify_mc_password_specialChars',
        value => isValidCrefoPassword(value).checks.specialChars
    )
    defineRule(
        'verify_mc_password_validChars',
        value => isValidCrefoPassword(value).checks.validChars
    )
    defineRule('ascii_only', value => {
        if (typeof value !== 'string') {
            return false
        }
        return [...value].every(char => char.charCodeAt(0) <= 127)
    })

    const isDefinedAndNotEmpty = (form, field) =>
        form[field] && form[field] !== ''
    const isAnyFieldDefinedAndNotEmpty = (form, fields) =>
        fields.some(field => isDefinedAndNotEmpty(form, field))
    const validateFieldWithDependencies = (value, fields, form) =>
        !(value === '' && isAnyFieldDefinedAndNotEmpty(form, fields))
    defineRule('validate_birthdate', (value, [d, m, y], ctx) => {
        return validateFieldWithDependencies(value, [d, m, y], ctx.form)
    })
    defineRule(
        'validate_phone',
        (value, [countryCode, areaCode, subscriptionNumber], ctx) => {
            return validateFieldWithDependencies(
                value,
                [countryCode, areaCode, subscriptionNumber],
                ctx.form
            )
        }
    )

    const isNumeric = value => !!value && /^[0-9]+$/.test(value)
    defineRule('validate_areacode', value => {
        if (isEmpty(value)) {
            return true
        }
        if (isNumeric(value)) {
            return String(value).replace(/^0+/, '') === String(value)
        }

        return false
    })
    defineRule('validate_numeric', value => {
        if (isEmpty(value)) {
            return true
        }
        return isNumeric(value)
    })

    configure({
        generateMessage: localize({
            de,
            en,
            fr
        })
    })

    setLocale(defaultLocale)
}
